// extracted by mini-css-extract-plugin
export default {"wrapper":"MlKM3sLQoK","disabled":"_3QvG9DTgvC","dot":"RpTTcFBF2T","radio":"WFqx5poCgf","label":"VyhIR17r9F"};